import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/social';
import { images } from '../data/offer';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let showTimer: number;
    const show = () => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        showTimer = window.setTimeout(() => {
          setIndex(i => (i + 1) % recentBuyers.length);
          show();
        }, GAP_MS);
      }, VISIBLE_MS);
    };
    showTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(showTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:bottom-28 sm:left-5 sm:right-auto" aria-live="polite" data-id="element-309" data-mp="117ft09vkm7v1">
      <AnimatePresence data-id="element-310" data-mp="1fv969nx6oyag">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(11,27,51,0.22)] ring-1 ring-ink/5 sm:w-[340px]" data-id="element-311" data-mp="1aw6205p12w3j">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-312" data-mp="28k7qcqkvaaie" />
            <div className="min-w-0" data-id="element-313" data-mp="23lwg4eqntxzn">
              <p className="truncate text-sm font-extrabold text-ink" data-id="element-314" data-mp="23kv4a81tl7gv">
                {buyer.name} <span className="font-medium text-muted" data-id="element-315" data-mp="2anjlrmvdglaz">from {buyer.country}</span>
              </p>
              <p className="text-[13px] leading-snug text-ink/80" data-id="element-316" data-mp="2fmcxpav0g491">just purchased Perio Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-cta" data-id="element-317" data-mp="2ko2b2x5pgu0a">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-318" data-mp="2pkiyfp52z4cb" /> Verified purchase · {buyer.time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-cream hover:text-ink" data-id="element-319" data-mp="1rw8uv5pnc8j3">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-320" data-mp="26osvnzpbq3xd" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}